module.exports = __webpack_public_path__ + "static/img/video-frame.e2c4da8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video-frame.png
// module id = lpDW
// module chunks = 0